
import { Button, Row, Form, message, Input, Select } from 'antd';
import React, { useState, useMemo, useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { FormComponentProps } from 'antd/lib/form';
import { IStateDepartment } from 'src/entity/StateEntity';
import { RouterConfig } from 'src/routers/urlConfig';
import DepartmentAdminService, { StaffRoleDict } from 'src/services/DepartmentAdminService';
import I18N from 'src/services/I18NService';
import { IStaffDetail, StaffAuths, StaffRoles } from 'src/entity/DepartmentEntity';
import { Dispatch } from 'redux';
import { fetchDepartmentsIfNeeded } from 'src/redux/actions/departmentCreator';


interface IProps extends FormComponentProps<{}>, RouteComponentProps {
  isDomestic: boolean,
  departmentState: IStateDepartment,
  isAgent: boolean,
  dispatch: Dispatch<IStateDepartment>
}

const defaultUserDetail: IStaffDetail = {
  uuid: '',
  code: '',
  department: '',
  username: '',
  fullname: '',
  mobile: '',
  password: '',
  role: StaffRoles.Assist,
  is_active: true,
  data_auth: StaffAuths.Institution,
  email: '',
}

const formItemLayout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 8
  },
};

/**
 * 新增操作员(暂不支持修改)
 */
const UserAdminEditForm: React.FC<IProps> = (props) => {
  const {
    history,
    form,
    isDomestic,
    departmentState,
    isAgent,
    dispatch,
  } = props;
  const { getFieldDecorator } = form;
  
  // 顶层部门uuid
  const topDepartmentId = useMemo(() => {
    let result: string = '';
    const { list } = departmentState;
    if (list) {
      const topDepartment = list.find(item => !item.parent);
      if (topDepartment) {
        result = topDepartment.uuid;
      }
    }
    return result;
  }, [departmentState]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // 初次渲染时 => 部门列表 
    dispatch(fetchDepartmentsIfNeeded());
  }, []);

  const handleGoback = () => {
    history.push({
      pathname: `${RouterConfig.Urls.userAdmin}`,
      state: {useCache: true}, // 查询条件使用缓存
    });
  }

  const handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    form.validateFields(async (err, values: IStaffDetail) => {
      if (!err) {
        const {
          username,
          fullname,
          password,
          mobile,
          role,
          email,
        } = values;
        const params: Partial<IStaffDetail> = {
          username,
          fullname,
          department: topDepartmentId,
          password,
          mobile,
          role,
          data_auth: StaffAuths.Institution,
          email,
        };
        if (isDomestic) {
          delete params.email;
        } else {
          delete params.mobile;
        }
        setLoading(true);
        let res: IStaffDetail | undefined;
        if (isAgent) {
          res = await DepartmentAdminService.createDepartmentStaff(params);
        } else {
          res = await DepartmentAdminService.createDrugstoreStaff(params);
        }
        setLoading(false);
        if (res) {
          message.success(I18N.get('common_submit_success'));
          handleGoback();
        }
      }
    });
  };

  return (
    <section style={{padding: '0 36px'}}>
      <Row type="flex" align="middle" justify="space-between" style={{marginBottom: 16}}>
        <span style={{fontSize: 16, color: '#1fb8cd'}}>{I18N.get('nav_userAdmin_add')}</span>
        <Button type="primary" onClick={handleGoback}>
          {I18N.get('common_back')}
        </Button>
      </Row>
      <Form
        className="mdd-search-form"
        style={{width: 500, margin: '0 auto'}}
        {...formItemLayout}
      >
        <Form.Item label={I18N.get('login_userName')}>
          {getFieldDecorator(`username`, {
            initialValue: defaultUserDetail.username,
            rules: [
              {
                required: true,
                message: `${I18N.get('common_input')}${I18N.get('login_userName')}`,
              },
            ],
          })(
            <Input
              autoComplete="off"
              placeholder={`${I18N.get('common_input')}${I18N.get('login_userName')}`}
            />
          )}
        </Form.Item>
        {isAgent && (
          <Form.Item label={I18N.get('common_name')}>
            {getFieldDecorator('fullname', {
              initialValue: defaultUserDetail.fullname,
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_input')}${I18N.get('common_name')}`
                }
              ]
            })(
              <Input
                autoComplete="off"
                placeholder={`${I18N.get('common_input')}${I18N.get('common_name')}`}
              />
            )}
          </Form.Item>
        )}
        {isDomestic && (
          <Form.Item label={I18N.get('common_mobile')}>
            {getFieldDecorator(`mobile`, {
              initialValue: defaultUserDetail.mobile,
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_input')}${I18N.get('common_mobile')}`,
                },
                {
                  pattern: /^((13)|(14)|(15)|(16)|(17)|(18)|(19))\d{9}$/,
                  message: `${I18N.get('err_mobile')}`,
                },
              ],
              
            })(
              <Input
                autoComplete="off"
                placeholder={`${I18N.get('common_input')}${I18N.get('common_mobile')}`}
              />
            )}
          </Form.Item>
        )}
        {!isDomestic && (
          <Form.Item label="Email">
            {getFieldDecorator(`email`, {
              initialValue: defaultUserDetail.email,
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_input')} Email`,
                },
                {
                  pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
                  message: `${I18N.get('err_email')}`,
                },
              ],
              
            })(
              <Input
                autoComplete="off"
                type="email"
                placeholder={`${I18N.get('common_input')} Email`}
              />
            )}
          </Form.Item>
        )}
        <Form.Item label={I18N.get('login_pwd')}>
          {getFieldDecorator(`password`, {
            initialValue: defaultUserDetail.password,
            rules: [
              {
                required: true,
                message: `${I18N.get('common_input')}${I18N.get('login_pwd')}`,
              },
              {
                min: 8,
                max: 20,
                message: `${I18N.get('login_pwd_require')}`,
              },
            ],
          })(
            <Input
              autoComplete="off"
              placeholder={`${I18N.get('common_input')}${I18N.get('login_pwd')}(${I18N.get('login_pwd_require')})`}
            />
          )}
        </Form.Item>
        <Form.Item label={I18N.get('userAdmin_role')}>
          {getFieldDecorator(`role`, {
            initialValue: defaultUserDetail.role,
            rules: [
              {
                required: true,
                message: `${I18N.get('common_choose')}${I18N.get('userAdmin_role')}`,
              },
            ],
          })(
            <Select
              placeholder={`${I18N.get('common_choose')}${I18N.get('userAdmin_role')}`}
            >
              {
                StaffRoleDict.map(option => {
                  if (option.value === StaffRoles.Assist) {
                    return (
                      <Select.Option key={option.key} value={option.value}>
                        {I18N.get(option.key)}
                      </Select.Option>
                    );
                  } else {
                    return null;
                  }
                })
              }
            </Select>
          )}
        </Form.Item>
        <Row type="flex" justify="center" style={{marginTop: 30}}>
          <Button
            type="primary"
            onClick={handleSubmit}
            loading={loading}
          >{I18N.get('common_ok')}</Button>
          <Button
            onClick={handleGoback}
            style={{marginLeft: 16}}
          >{I18N.get('common_cancel')}</Button>
        </Row>
      </Form>
    </section>
  )
}

const UserAdminEditPage = Form.create<IProps>()(UserAdminEditForm);
export default UserAdminEditPage;



// WEBPACK FOOTER //
// ./src/components/views/UserAdmin/UserAdminEditPage.tsx